import type { EstadoCaso } from '../../api/mejoraCU2Api';
import type { FctFamilia, FctNivelAtencion, FctNombreIcono } from '../../fct/react';

export const ESTADO_LABEL: Record<EstadoCaso, string> = {
  NUEVO: 'Nuevo',
  EN_ANALISIS: 'En análisis',
  INFO_SOLICITADA: 'Info solicitada',
  RESUELTO: 'Resuelto',
  CERRADO: 'Cerrado',
  RECHAZADO: 'Rechazado',
  REABIERTO: 'Reabierto',
};

/**
 * Familia del semáforo + icono por estado (GCVSC-I001 R-11, `mapeo-estados.md` §D.2). Rechazado
 * es un cierre, no un «va mal»: va en neutro con el icono de cancelado, no en rojo.
 */
export const ESTADO_FAMILIA: Record<EstadoCaso, { familia: FctFamilia; icono: FctNombreIcono }> = {
  NUEVO: { familia: 'proceso', icono: 'transmision' },
  EN_ANALISIS: { familia: 'proceso', icono: 'buscar' },
  INFO_SOLICITADA: { familia: 'aviso', icono: 'hora' },
  RESUELTO: { familia: 'exito', icono: 'completado' },
  CERRADO: { familia: 'neutro', icono: 'carpeta' },
  RECHAZADO: { familia: 'neutro', icono: 'cancelado' },
  REABIERTO: { familia: 'proceso', icono: 'volver' },
};

/** La prioridad no es un estado sino atención: glifo (Alta urgente, Media atención) + texto; Baja solo texto. */
export const PRIORIDAD_NIVEL: Record<string, FctNivelAtencion> = { Alta: 'urgente', Media: 'atencion', Baja: 'normal' };

export interface Capacidades { tratar: boolean; gestionar: boolean; }

type Recurso = 'Tratar' | 'Gestionar';
interface Transicion { origen: EstadoCaso; destino: EstadoCaso; recurso: Recurso; exigeTratamiento?: boolean; exigeMejora?: boolean; }

// Espejo exacto de MejoraCU2Transiciones (backend).
export const TRANSICIONES: Transicion[] = [
  { origen: 'NUEVO', destino: 'EN_ANALISIS', recurso: 'Tratar' },
  { origen: 'EN_ANALISIS', destino: 'INFO_SOLICITADA', recurso: 'Tratar' },
  { origen: 'INFO_SOLICITADA', destino: 'EN_ANALISIS', recurso: 'Gestionar' },
  { origen: 'EN_ANALISIS', destino: 'RESUELTO', recurso: 'Tratar', exigeTratamiento: true, exigeMejora: true },
  { origen: 'EN_ANALISIS', destino: 'RECHAZADO', recurso: 'Tratar', exigeTratamiento: true },
  { origen: 'RESUELTO', destino: 'CERRADO', recurso: 'Gestionar' },
  { origen: 'RESUELTO', destino: 'REABIERTO', recurso: 'Gestionar' },
  { origen: 'RECHAZADO', destino: 'CERRADO', recurso: 'Gestionar' },
  { origen: 'RECHAZADO', destino: 'EN_ANALISIS', recurso: 'Gestionar' },
  { origen: 'REABIERTO', destino: 'EN_ANALISIS', recurso: 'Tratar' },
  { origen: 'CERRADO', destino: 'REABIERTO', recurso: 'Gestionar' },
];

export const transicionesDisponibles = (estado: EstadoCaso, cap: Capacidades): Transicion[] =>
  TRANSICIONES.filter(t => t.origen === estado &&
    ((t.recurso === 'Tratar' && cap.tratar) || (t.recurso === 'Gestionar' && cap.gestionar)));

export const ACCION_LABEL: Record<EstadoCaso, string> = {
  EN_ANALISIS: 'Pasar a análisis',
  INFO_SOLICITADA: 'Solicitar información',
  RESUELTO: 'Marcar resuelto',
  CERRADO: 'Cerrar',
  RECHAZADO: 'Rechazar',
  REABIERTO: 'Reabrir',
  NUEVO: 'Nuevo',
};
